import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../redux/store';
import { MultiActionArrowsContainer } from './multiActionArrowsContainer';
import { SingleActionArrowContainer } from './singleActionArrowContainer';
export const ActionArrowsContainer = () => {
    const actionTimerSeatIndexes = useAppSelector((state) => state.poker.actionTimer?.seatIndexes, shallowEqual);
    const isDiscardPhase = useAppSelector((state) => state.poker.isDiscardPhase);
    if (!actionTimerSeatIndexes || !actionTimerSeatIndexes.length) {
        return null;
    }
    if (actionTimerSeatIndexes.length > 1 || isDiscardPhase) {
        return _jsx(MultiActionArrowsContainer, { actionTimerSeatIndexes: actionTimerSeatIndexes });
    }
    return _jsx(SingleActionArrowContainer, { actionTimerSeatIndex: actionTimerSeatIndexes[0] });
};
